import { AdobeAnalytics } from './AdobeAnalytics';
import { InterfaceContext } from '../model/InterfaceProvider';
import { useContext, useEffect } from 'react';

export const Analytics = () => {
    const { tab, scope, theme, state, tract, year } = useContext(InterfaceContext);

    const dataToSlug = () => {
        // console.log(year, theme, scope, state, tract);
        return [year.label, theme.label, scope === 'national' ? 'US' : state?.label || '', tract].join('-').replace(' ', '-').toLowerCase();

        //2020-overall-US-Alabama-county
    };
    ////theme, scope, state, tract, year

    //create new hook, use legit hit (set a timeout in the hook 1 sec or 500 ms before tracking)
    useEffect(() => {
        AdobeAnalytics.sendPageView(tab.label);
    }, [tab]);

    useEffect(() => {
        const dataSlug = dataToSlug();
        // console.log('send data slug');
        AdobeAnalytics.sendInteraction('data-view', dataSlug);
    }, [year, theme, scope, state, tract]);

    return null;
};
